import FaqSettings from "../../components/feature/settings/faq/faq-settings";
import { memo } from "react";
import SettingsTabPage from "../../components/feature/settings/settings-tab-page";

const FaqTab = () => {
  return (
    <SettingsTabPage>
      <FaqSettings />
    </SettingsTabPage>
  );
};

export default memo(FaqTab);
